import React, { useEffect, useState } from "react";
import Select from "react-select";
import { fetchJson } from "../../lib/Fetching";

export default function DataFieldNameDropdown({ value, onChange, placeholder }) {
  const [options, setOptions] = useState([]);

  const handleChange = (option) => onChange(option ? option.value : undefined);

  const fetchData = () =>
    fetchJson("/products/admin/data_field_names.json", {}).then((json) => {
      const options = json.map((m) => ({ label: m.name, value: m.id }));
      setOptions(options);
    });

  useEffect(() => {
    fetchData();
  }, []);

  if (options.length == 0) return null;

  const selectedValue = value ? options.filter((o) => o.value == value) : undefined;

  return (
    <Select
      value={selectedValue}
      placeholder={placeholder || "Select data field names"}
      isMulti={false}
      autoload={true}
      id="data_field_name_id"
      options={options}
      onChange={handleChange}
      isClearable={true}
    />
  );
}
